<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('setupLandingPage.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t('setupLandingPage.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-sm-4">
            <ts-button color="info" outline @click="showForm()">{{
              $t('add_new')
            }}</ts-button>
          </div>
          <div class="col-sm-8 d-flex justify-content-end">
            <ts-input
              v-model="search"
              :placeholder="$t('search')"
              style="width: 300px"
            />
          </div>
        </div>
      </ts-card-wrapper>
      <ts-table :columns="columns" :records="resources" :loading="loading">
        <template v-slot="{ record }">
          <td style="width: 10%">
            <img
              v-if="record.lpt_id != 6"
              class="height-30 ts-rounded"
              v-lazy="{
                src: photo(record),
                error: onError(record),
                loading: require('@/assets/Rolling-1s-200px_2.svg')
              }"
            />
          </td>
          <td style="width: 20%">
            {{
              record.landing_page_type
                ? record.landing_page_type.landing_page_type
                : ''
            }}
          </td>
          <td style="width: 30%">
            <div v-if="record.lpt_id == 6">{{ record.logo }}</div>
            <select v-model="record.object_ref_id" v-if="record.lpt_id == 1">
              <option
                v-for="(op, index) in mainProgramOptions"
                :key="index"
                :value="op.id"
              >
                {{ op.label }}
              </option>
            </select>
            <select v-model="record.object_ref_id" v-if="record.lpt_id == 2">
              <option
                v-for="(op, index) in subProgramOptions"
                :key="index"
                :value="op.id"
              >
                {{ op.label }}
              </option>
            </select>
            <select v-model="record.object_ref_id" v-if="record.lpt_id == 3">
              <option
                v-for="(op, index) in partnerOptions"
                :key="index"
                :value="op.id"
              >
                {{ op.label }}
              </option>
            </select>
          </td>
          <td>
            <div v-if="record.description.length < 255">
              <div v-html="record.description"></div>
            </div>
            <div v-else>
              <div v-html="record.description.substring(0, 255) + '..'"></div>
            </div>
          </td>
          <td class="text-center">
            <a
              href="#"
              v-tooltip="$t('edit')"
              class="mr-2 text-primary"
              @click.prevent="showEditForm(record)"
            >
              <i class="fas fa-edit"></i>
            </a>
            <a
              href="#"
              v-tooltip="$t('delete')"
              class="text-danger"
              @click.prevent="destroy(record)"
              :disabled="record._deleting"
            >
              <i class="fas fa-circle-notch spin" v-if="record._deleting"></i>
              <i class="fas fa-trash" v-else></i>
            </a>
          </td>
        </template>
      </ts-table>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
    </ts-card>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import FormComponent from './create'
import EditFormComponent from './edit'
export default {
  name: 'landingPage',
  data () {
    return {
      loading: false,
      mainProgramOptions: null,
      subProgramOptions: null,
      partnerOptions: null
    }
  },
  async created () {
    await this.getMainProgram()
    await this.getSubProgram()
    await this.getPartner()
    await this.fetchData()
  },
  computed: {
    ...mapState('setupLandingPage', ['resources', 'pagination']),
    columns () {
      return [
        {
          name: this.$t('setupLandingPage.image')
        },
        {
          name: this.$t('setupLandingPage.landingPageType')
        },
        {
          name: this.$t('setupLandingPage.objectName')
        },
        {
          name: this.$t('setupLandingPage.description')
        },
        { name: this.$t('actions'), style: 'text-align:center;width: 2%' }
      ]
    },
    search: {
      get () {
        return this.$store.state.setupLandingPage.search
      },
      set (newValue) {
        this.$store.commit('setupLandingPage/SET_SEARCH', newValue)
        this.$store.commit('setupLandingPage/RESET_CURRENT_PAGE')
      }
    }
  },
  methods: {
    getMainProgram () {
      this.mainProgramOptions = null
      this.$store
        .dispatch('setupLandingPage/fetchMainProgram')
        .then(response => {
          this.mainProgramOptions = response.data.map(el => ({
            id: el.acp_id,
            label: el.acp_name_foreign
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
    },
    getSubProgram () {
      this.subProgramOptions = null
      this.$store
        .dispatch('setupLandingPage/fetchSubProgram')
        .then(response => {
          this.subProgramOptions = response.data.map(el => ({
            id: el.acps_id,
            label: el.acps_name_foreign
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
    },
    getPartner () {
      this.partnerOptions = null
      this.$store
        .dispatch('setupLandingPage/fetchCorporatePartner')
        .then(response => {
          this.partnerOptions = response.data.map(el => ({
            id: el.cpp_id,
            label: el.partner_name_en
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
    },

    photo (record) {
      if (record.logo) {
        return record.logo
      }
      return this.file
    },

    onError () {
      event ? (event.target.src = this.file) : ''
    },
    showForm (data) {
      this.$modal.show(
        FormComponent,
        {
          data: data
        },
        {
          height: 'auto',
          width: '50%',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: false
        },
        {
          'before-close': this.fetchData
        }
      )
    },
    showEditForm (editData) {
      this.$modal.show(
        EditFormComponent,
        {
          editData: editData
        },
        {
          height: 'auto',
          width: '50%',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: false
        },
        {
          'before-close': this.fetchData
        }
      )
    },
    fetchData (attributes) {
      this.loading = true
      this.$store
        .dispatch('setupLandingPage/fetch', attributes)
        .then(() => {
          this.loading = false
        })
        .catch(errors => {
          this.loading = false
          this.$toasted.error(errors.message)
        })
    },
    async destroy (record) {
      if (await this.$confirmModal.danger(this.$t('are_you_sure_to_delete'))) {
        record._deleting = true
        this.$store
          .dispatch('setupLandingPage/destroy', record.id)
          .then(response => {
            this.fetchData()
            this.$toasted.success(response.message)
            record._deleting = false
          })
          .catch(errors => {
            this.$toasted.error(errors.message)
            record._deleting = false
          })
      }
    }
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData({ search })
    }, 500)
  },
  beforeRouteLeave (to, from, next) {
    this.$store.commit('setupLandingPage/RESET_STATE')
    next()
  }
}
</script>
<style lang="css" scoped>
table td {
  vertical-align: middle;
}
select::-ms-expand {
  display: none;
}
select {
  -webkit-appearance: none;
  appearance: none;
  text-align: center;
  text-align-last: center;
}
</style>
